import { FC, useCallback, useEffect, useRef, useState } from "react";
import { DecimalSchemaItem, RowWithEmbeddedMetadata } from "@data-root/types";
import { SchemaItemProps, useField } from "@data-root/react";
import { inputGuard } from "../../hocs/guard";
import { View } from "@data-root/react";
import { InputNumber, Skeleton } from "antd";
import { Typography } from "antd";
import { Remarks } from "../remarks";
const { Title } = Typography;

export const DecimalInput: FC<SchemaItemProps<DecimalSchemaItem>> = inputGuard(
  ({ item }) => {
    const {
      loaded,
      displayName,
      placeholder,
      editable,
      show,
      defaultValue,
      subscribe,
      setValue: _setValue,
      remarks,
    } = useField<number>(item);

    const [value, setValue] = useState<number | null>(defaultValue);

    const handleSetValue = useCallback(
      (value: number | null) => {
        if (value === null) {
          setValue(null);
          _setValue(null, "");
          return;
        }

        setValue(value);
        _setValue(value, value?.toString() || "");
      },
      [_setValue]
    );

    useEffect(() => {
      const callback = (
        next: RowWithEmbeddedMetadata,
        options?: {
          init?: boolean;
          evaluation?: boolean;
        }
      ) => {
        if (options?.init) {
          setValue(next[item.id] as number);
          return;
        }
        if (!options?.evaluation) return;

        setValue(next[item.id] as number);
      };

      const unsubscribe = subscribe(callback);

      return () => {
        unsubscribe();
      };
    }, [item.id, subscribe]);

    if (!show) return null;

    return (
      <View style={{ width: "100%" }}>
        <Title level={5}>{displayName}</Title>

        {!loaded ? (
          <Skeleton.Input block active />
        ) : (
          <InputNumber
            style={{ width: "100%" }}
            min={item.min}
            max={item.max}
            readOnly={!editable}
            disabled={!editable}
            placeholder={placeholder}
            value={value}
            onChange={handleSetValue}
            inputMode="decimal"
          />
        )}

        <Remarks texts={remarks} />
      </View>
    );
  }
);
